import dayjs from 'dayjs'
import isMobile from 'ismobilejs'
import asyncModule from './event'
import moduleList from '@/modules'
import store, { importWechatModules, importActivitiesManagerModules } from '@/store'
import notFoundModule from './not-found-module/index'
import API from '@/api'
import activitiesManager from '../activities-manager/main'
import Utils from '@/common/js/utils'
import initMixin from '@/common/js/init-mixin'

const PC_REDIRECT_URL = 'http://www.shenhudong.com/module_pc/indexMini.php?id='

/**
 * 【坑】
 * 这里所有的枚举常量都要用数字格式
 * 判断的时候，变量必须先转成数字然后再与常量进行比较
 * 因为后台PHP代码的问题，后台响应的json数据
 * 在Linux机器上返回的是字符串格式，
 * 但在本地docker环境返回的却是数字格式
 */
const ACTIVITIES_UNRELEASED = 0
const ACTIVITIES_NOT_START = 3
const ACTIVITIES_ONGOING = 1
const ACTIVITIES_ENDED = 2

// type： '1' === 互动营销  '3' === 活动管家  '5' === 地推应用
const MODULE_ENUM = {
  ACTIVITIES: 1,
  ACTIVITIES_MANAGER: 3,
  BD_APP: 5,
}
const routerRoot = {
  render() {
    return <router-view />
  }
}

/**
 * h5 入口
 */
const moduleEntry = {
  store,
  mixins: [initMixin],
  components: {
    asyncModule,
    notFoundModule,
    activitiesManager
  },
  data() {
    return {
      checked: false,
      moduleType: null
    }
  },
  async mounted() {
    // 非移动端 跳转至 PC 端引导页面
    const isMobileDevice = new isMobile.Class(window.navigator.userAgent).any
    if (!isMobileDevice) {
      return window.location.replace(PC_REDIRECT_URL + this.$route.params.eventId)
    }

    // 根据 URL 固化信息至本地
    this.getTokenFromUrl()

    // 没有授权则点击后跳转授权
    const openid = this.$storage.getItem('openid')
    if(openid){
      // 判断重定向授权页后
      let getWebUrlResp
      try {
        getWebUrlResp = await this.getWebUrl()
      } catch (err) {
        return
      }
      this.$storage.setItem('sub', getWebUrlResp.sub)
      this.$storage.setItem('org_index', getWebUrlResp.org_index)
    }else{
      $('.not-found-module-page').hide()
    }

    // get config
    let resp
    this.$storage.remove('prev_channel')
    try {
      resp = await this.$http({
        method: 'GET',
        url: API.common.getModel,
        params: {
          id: this.$route.params.eventId,
          token: this.$storage.getItem('token'),
          prev_uid: this.$storage.getItem('puid') != this.$storage.getItem('uid') ? this.$storage.getItem('puid'):0,
          openid: this.$storage.getItem('openid')
        }
      })
      if (!resp) {
        this.isNotFound = true
        return false
      }

      if(resp.staffInfo === null){
        this.$storage.remove('selfStaffInfo')
      }else{
        this.$storage.setItem('selfStaffInfo',JSON.stringify(resp.staffInfo))
      }

      if(resp.wechatStaffInfo === null){
        this.$storage.remove('wechatStaffInfo')
      }else{
        this.$storage.setItem('wechatStaffInfo',JSON.stringify(resp.wechatStaffInfo))
      }

      let config = JSON.parse(resp.config)
      if(!openid && moduleList[config.common.moduleName] === undefined && resp.module !== 'act_mger'){
        if(+this.getQueryString('is_case') === 1) {
          window.location.href = `https://hdcase.shenhudong.com/wxmini/${resp.module}/index.php?activity_id=${resp.id}&is_case=1`
        }else{
          window.location.href = `https://wx${resp.id}.shenhudong.com/wxmini/${resp.module}/index.php?activity_id=${resp.id}`
        }
      }

      if(resp.prev_channel){
        this.$storage.setItem('prev_channel',resp.prev_channel)
      }

      if(!openid){
        // 判断重定向授权页后
        let getWebUrlResp
        $('body').append(`<div id="toAuth" style="position: fixed;bottom: 0;left: 0;right: 0;top: 0;z-index: 100000;">
<img style="width: 100%;position: absolute;bottom: 0;" src="https://image.wxopen.shenhudong.com/shd_4/module/1011/%E7%82%B9%E5%87%BB%E8%BF%9B%E5%85%A5.png" alt="">
<img class="auth_point" style="width: 20%;position: absolute;bottom: 2%;right: 20%;" src="https://image.wxopen.shenhudong.com/shd_4/module/1011/%E6%89%8B%E6%8C%87.png" alt="">
</div>`)
        $('#toAuth').click(async () => {
          try {
            getWebUrlResp = await this.getWebUrl()
          } catch (err) {
            return
          }
        })
      }

      this.$storage.setItem('activities_manager_uid', resp.uid || 0)

      this.moduleType = resp.type
      const moduleConfig = JSON.parse(resp.config)

      // 活动的开始时间有可能和初始配置不同，需要覆盖
      moduleConfig.common.eventTime = [
        dayjs(resp.start_time).unix() + 10,
        dayjs(resp.end_time).unix() + 10
      ]

      if (+resp.activity_status === ACTIVITIES_UNRELEASED) {
        this.$bottomTips.init('此活动尚未发布，当前仅供预览', 'preview')
      }

      if (+resp.activity_status === ACTIVITIES_ENDED) {
        if (+this.moduleType !== MODULE_ENUM.ACTIVITIES_MANAGER) {
          this.$bottomTips.init('此活动已结束，当前仅供预览', 'preview')
        }
      }

      if (+this.moduleType === MODULE_ENUM.ACTIVITIES_MANAGER) {
        window.localStorage.removeItem('activity_lead')
        if(resp.lead !== null) window.localStorage.setItem('activity_lead',JSON.stringify(resp.lead))
        window.localStorage.setItem('activity_config',resp.config)
        window.localStorage.setItem('activity_title',resp.title)
        let info = Utils.deepClone(resp)
        importActivitiesManagerModules(info)

        // 初始化 loading 组件
        if (this.$store.state.activitiesManager.advance.useCustomLoadingIcon) {
          this.$logoLoading.initImgSrc(this.$store.state.activitiesManager.advance.loadingIcon.src)
        }
        // 初始化 audio 组件
        let shouldSetMusic
        try {
          shouldSetMusic = this.$store.state.activitiesManager.common.music.src && this.$store.state.activitiesManager.common.useBackgroundMusic
        } catch (error) {
          shouldSetMusic = false
        }
        if (shouldSetMusic) {
          this.$audio.initAudio({
            src: this.$store.state.activitiesManager.common.music.src
          })
        }
      }

      if ([MODULE_ENUM.ACTIVITIES, MODULE_ENUM.BD_APP].includes(+this.moduleType)) {
        window.SELECTED_MODULE = moduleConfig.common.moduleName
        window.document.title = moduleConfig.common.eventName
        process.env.NODE_ENV === 'development' && console.log(moduleConfig)

        // 注册模块 store
        await importWechatModules(moduleList[window.SELECTED_MODULE], moduleConfig)

        this.$store.dispatch('eventRuntime/changeEventProps', {
          key: 'joinCount',
          value: +resp.join_nums
        })

        // 设置活动状态
        // '0' 活动未开始
        // '1' 活动进行中
        // '2' 活动已结束
        this.$store.dispatch('eventRuntime/changeEventProps', {
          key: 'activityStatus',
          value: resp.activity_status
        })

        // 初始化 loading 组件
        if (this.$store.state.eventRuntime.advance.useCustomLoadingIcon) {
          this.$logoLoading.initImgSrc(this.$store.state.eventRuntime.advance.loadingIcon.src)
        }

        // 初始化 audio 组件
        if (this.$store.state.eventRuntime.common.useBackgroundMusic) {
          this.$audio.initAudio({
            src: this.$store.state.eventRuntime.common.backgroundMusic.src.replace('http://', 'https://'),
            music: this.$store.state.eventRuntime.module.elements.music
          })
        }

        // 初始化 bottom-tips 组件
        if (this.$store.state.eventRuntime.advance.footerAd) {
          this.$bottomTips.init()
        }

        if(this.$store.state.eventRuntime.common.orgName !== undefined){
          this.$consultDialog.init(this.$store.state.eventRuntime.common)
        }

        if(this.$store.state.eventRuntime.module.elements.consult){
          this.$consultBtn.init(this.$store.state.eventRuntime.module.elements.consult,this.$consultDialog)
        }


        if (
          resp.activity_status !== ACTIVITIES_UNRELEASED &&
          (resp.activity_status !== ACTIVITIES_ENDED)
        ) {
          // 初始化 countdown 组件
          this.$countdown.init.apply(this, this.$store.state.eventRuntime.common.eventTime)
        }
      }
    } catch (error) {
      this.isNotFound = true
      console.error(error)
    } finally {
      this.checked = true
    }
    this.sendStayTime(1)
    this.staytimer = setInterval(() => {
      this.sendStayTime(2)
    }, 5000);
  },
  methods: {
    /**
  *  统计停留页面时长
  */
    sendStayTime(type) {
      const activityId = this.$route.params.eventId
      const openid = this.$storage.getItem('openid')
      const token = this.$storage.getItem('token')
      this._sendStayTime({
        type: type,
        activityId,
        openid,
        token
      })
    },
    getQueryString(name) {
      let reg = `(^|&)${name}=([^&]*)(&|$)`
      let r = window.location.search.substr(1).match(reg)
      if (r !== null) return unescape(r[2]); return null
    },
  },
  render() {
    if (this.checked) {
      // 404
      if (this.isNotFound) {
        return <not-found-module />
      }
      if (+this.moduleType === MODULE_ENUM.ACTIVITIES_MANAGER) {
        return <activities-manager />
      }
      return (
        <async-module module-id={window.SELECTED_MODULE} />
      )
    }

    return <div style="z-index: 9999; background:#fff;position: fixed;left: 0;right:0;top:0;bottom: 0;"></div>
  }
}

export { routerRoot }
export default moduleEntry